module.exports = __webpack_public_path__ + "static/media/logo_m.41953d3b.png";